import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TGenericIssueDTO } from '@monorepo/types';

@Component({
  selector: 'monorepo-filter-reject-v2-list',
  templateUrl: './filter-reject-v2-list.component.html',
  styleUrls: ['./filter-reject-v2-list.component.scss'],
})
export class FilterRejectV2ListComponent implements OnInit {
  @Input() lists: TGenericIssueDTO[] = [];
  selectedLists: TGenericIssueDTO[] = [];
  @Input() preSelectedLists: TGenericIssueDTO[] = [];
  @Input() title = '';
  backArrow = '/assets/md-point/header-back-arrow.svg';

  constructor(private modalCtrl: ModalController) {}

  ngOnInit(): void {
    this.selectedLists = this.preSelectedLists;
  }

  handleOperationOrRejectReasonSelection(list: TGenericIssueDTO[]) {
    this.selectedLists = list;
  }

  handleSelectAll() {
    if (this.selectedLists.length === this.lists.length) this.selectedLists = [];
    else this.selectedLists = this.lists;
  }

  handleCancel() {
    this.modalCtrl.dismiss();
  }

  handleApply() {
    this.modalCtrl.dismiss(this.selectedLists);
  }
}
